import BaseService from "@/boot/BaseService";
class TablaGenericaService extends BaseService {
  constructor() {
    super(null, "/tabla-generica");
  }
  async provincias() {
    return await this.get("/provincias");
  }
}

export default new TablaGenericaService();
